import script from "./ClientsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsList.vue?vue&type=script&setup=true&lang=js"

export default script